(function ($) {
    $(document).ready(function () {
        var linker = new Linker();

        $('.mini-articles')
            .accordion()
        ;
    });

    function Linker(options) {
        this.init(options);
    }

    Linker.prototype = {
        defaultParams : {
            selector: {
                iconContainer: '.tab-icons-container',
                icon: '.tab-icon-container',
                tabContainer: '.tabs-container',
                tab: '.tab-content'
            },
            data : {
                type: 'tab-type'
            }
        },

        extend: function(destination, source){
            for (var property in source) {
                destination[property] = source[property];
            }
            return destination;
        },

        init: function(options) {
            var self = this;
            self.params = self.extend(self.defaultParams, options);

            self.bindIconsToTabs();
        },

        bindIconsToTabs: function () {
            var self = this,
                params = self.defaultParams,
                selector = params.selector,
                data = params.data;

            if (!$(selector.iconContainer))
                return false;

            var iconContainer = $(selector.iconContainer);

            markIcon($(iconContainer.children('[data-' + data.type +'=advert]')));
            showTab('advert');

            iconContainer.on('click', selector.icon, function () {
                var icon = $(this),
                    type =  icon.data(data.type);

                freeAllIcons();
                markIcon(icon);

                hideAllTabs();
                showTab(type);
            });

            function freeAllIcons() {
                $(selector.icon).removeClass('active');
            }

            function markIcon(icon) {
                icon.addClass('active');
            }

            function hideAllTabs() {
                $(selector.tab).hide();
            }

            function showTab(type) {
                $(selector.tabContainer).children('[data-' + data.type +'=' +  type +']').show();
            }
        }

    };
})(jQuery);



// WEBPACK FOOTER //
// ./assets/javascript/fleshkioptom.js